import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {updateTicketMutation, UpdateTicketInput} from './__generated__/updateTicketMutation.graphql';

const mutation = graphql`
	mutation updateTicketMutation($input: UpdateTicketInput!) {
		updateTicket(input: $input) {
			clientMutationId
			ticket {
				id
				status
				priority
				channel
				assigneeId
				assignee {
					id
					fullName
					...ticketingPerson_person
				}
			}
		}
	}
`;

export interface UpdateTicketCommitInput {
	input: UpdateTicketInput;
	optimisticResponse?: Record<string, unknown>;
}

function commit(
	environment: Environment,
	commitInput: UpdateTicketCommitInput,
	onCompleted?: (r: updateTicketMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	const {input, optimisticResponse} = commitInput;
	return commitMutation<updateTicketMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		optimisticResponse: optimisticResponse as never,
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'updateTicketMutation'};
